import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext } from '@ngxs/store';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AccountApiService } from '../../service/account-api.service';
import { RegistrationActions } from './registration.actions';

export interface RegistrationStateModel {
  startRegistrationData;
}

@State<RegistrationStateModel>({
  name: 'registration',
})
@Injectable()
export class RegistrationState {
  constructor(
    private readonly accountApiService: AccountApiService,
    private readonly router: Router
  ) {}

  static startRegistrationData() {
    return createSelector(
      [RegistrationState],
      (state: RegistrationStateModel) => {
        return state.startRegistrationData;
      }
    );
  }

  @Action(RegistrationActions.StartRegistration)
  async saveToken(
    ctx: StateContext<RegistrationStateModel>,
    payload: RegistrationActions.StartRegistration
  ) {
    await firstValueFrom(
      this.accountApiService.startRegistration(payload.registrationData)
    );
    ctx.patchState({
      startRegistrationData: payload.registrationData,
    });
    this.router.navigate(['auth', 'registration-complete'], {
      queryParams: {
        email: payload.registrationData.email,
      },
    });
  }
}
